import { defineComponent as _defineComponent } from 'vue';
import { onMounted } from 'vue';
import DatePicker from '@blade/common/components/date-time-select/index.vue';
import SliderInput from '@blade/common/components/slider-input/index.vue';
import { useRecordForm } from '@blade-sxp/monitoring-center/pages/record/utils/useRecordForm';
import DeviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import { RecordTimeOptions, RecordDefaultTime } from '@blade-sxp/monitoring-center/utils/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'record-form',
    props: {
        query: null
    },
    emits: ['updateSnapData', 'updateGroupTime'],
    setup(__props, { emit }) {
        const props = __props;
        const { form, getSnapImage, groupTimeChange, handleReset } = useRecordForm(props.query, emit);
        onMounted(() => {
            handleReset(); // 初始化form数据
        });
        return { __sfc: true, props, emit, form, getSnapImage, groupTimeChange, handleReset, DatePicker, SliderInput, DeviceSelect, RecordTimeOptions, RecordDefaultTime };
    }
});
